import React from "react";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import Login from "./auth/Login.jsx";
import { useParams } from "react-router-dom";
import Header from "./components/Header.jsx";
import Dashboard from "./components/Dashboard.jsx";
import ServiceReport from "./components/ServiceReport.jsx";
import Sidebar from "./components/Sidebar.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/theme/black.css";
import "./assets/css/chat.css";
import "./assets/css/custom.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-bs4";
import "./assets/css/style.min.css";
import RoleManager from "./hrms/role/Role.jsx";
import UserManagement from "./hrms/user/UserManagement.jsx";
import AddRole from "./hrms/role/AddRole.jsx";
import AddUserRole from "./hrms/role/AddUserRole.jsx";
import AddUser from "./hrms/user/AddUser.jsx";
import AddSubuser from "./hrms/user/AddSubuser.jsx";
import DistributorUserManagement from "./hrms/distributor-user/DistributorUserManagement.jsx";
import AddDistributorUser from "./hrms/distributor-user/AddDistributorUser.jsx";
import AddDistributorSubuser from "./hrms/distributor-user/AddDistributorSubuser.jsx";
import ChangePassword from "./profile/ChangePassword.jsx";
import EditProfile from "./profile/EditProfile.jsx";
import Profile from "./profile/Profile.jsx";
import MyDashboard from "./components/MyDashboard.jsx";
import DistributorDashboard from "./components/DistributorDashboard.jsx";
import AnalysisDashboard from "./components/AnalysisDashboard.jsx";
import SalesAnalysisDashboard from "./salesAnalysis/SalesAnalysisDashboard.jsx";
import Markets from "./research/markets/Markets.jsx";
import PatternsRadar from "./research/patternsRadar/PatternsRadar.jsx";
import PatternsRadarSymbolDetail from "./research/patternsRadar/PatternsRadarSymbolDetail.jsx";
import CareparrvaOutput from "./research/careparrvaOutput/CareparrvaOutput.jsx";
import CareparrvaReportDetail from "./research/careparrvaOutput/CareparrvaReportDetail.jsx";
import AddNotifications from "./research/notifications/AddNotifications.jsx";
import Notifications from "./research/notifications/Notifications.jsx";
// Angel Notifications disabled - not required
// import AddAngelNotifications from "./research/AngelNotification/AddNotifications.jsx";
// import AngelNotifications from "./research/AngelNotification/Notifications.jsx";
import Watchlist from "./research/watchlist/Watchlist.jsx";
import Performance from "./research/performance/Performance.jsx";
import EditPerformance from "./research/performance/EditPerformance.jsx";
import Shareview from "./research/performance/Shareview.jsx";
import StreetStocks from "./research/streetstocks/StreetStocks.jsx";
import ViewHistory from "./research/streetstocks/ViewHistory.jsx";
import Services from "./research/Services/Services.jsx";
import SegmentManage from "./research/segment/index.jsx";
import SegmentForm from "./research/segment/add.jsx";
import Subscriber from "./Subscriber/index.jsx";
import AICallDashboard from "./Subscriber/AICallDashboard.jsx";
import SarvamVoiceDashboard from "./Subscriber/SarvamVoiceDashboard.jsx";
import SubscriberEdit from "./Subscriber/edit.jsx";

import SubscriberPortfolio from "./SubscriberPortfolio/index.jsx";
import Subscription from "./Subscriptions/index.jsx";
import SubscriptionPortfolio from "./SubscriptionPortfolio/index.jsx";
import SubscriptionPortfolioEdit from "./SubscriptionPortfolio/edit.jsx";
import SubscriptionCredits from "./SubscriptionCredits/index.jsx";
import SubscriptionCreditsEdit from "./SubscriptionCredits/edit.jsx";
import Order from "./order/index.jsx";
import CompanyProfile from "./settings/company/index.jsx";
import CompanyEditForm from "./settings/company/edit.jsx";
import ConfigForm from "./settings/company/editConfigs.jsx";
import WhatsappConfigForm from "./settings/company/editWhatsappConfigs.jsx";
import CallConfigForm from "./settings/company/editCallConfigs.jsx";
import CompanyOfferForm from "./settings/company/editOffer.jsx";
import PrintConfigForm from "./settings/company/editPrintConfigs.jsx";
import TestNotifixation from "./settings/company/testNotifixation.jsx";
import CarparvaLoginForm from "./settings/company/carparvaLogin.jsx";
import CarparvaOutputLoginForm from "./settings/company/carparvaOutputLogin.jsx";
import PhilosophyVideoForm from "./settings/company/philosophyVideo.jsx";
import AiCallingPrompts from "./settings/AiCallingPrompts/index.jsx";
import AiCallingPromptForm from "./settings/AiCallingPrompts/form.jsx";
import DownloadPayslip from "./profile/Payslip.jsx";
import EmailConfigManagement from "./settings/EmailConfig/index.jsx";
import AddEmailConfigForm from "./settings/EmailConfig/add.jsx";
import EmailMapping from "./settings/EmailMapping/index.jsx";
import EmailMappingForm from "./settings/EmailMapping/add.jsx";
import TemplateLetterPage from "./settings/TemplateLetter/index.jsx";
import TemplateLetterForm from "./settings/TemplateLetter/add.jsx";
import TemplateEmailForm from "./settings/TemplateEmail/add.jsx";
import TemplateEmailList from "./settings/TemplateEmail/index.jsx";
import TemplateEmailHtmlEdit from "./settings/TemplateEmail/htmlEdit.jsx"; // HTML editor
import TemplateBuilderList from "./settings/TemplateBuilder/index.jsx";
import TemplateBuilderEditor from "./settings/TemplateBuilder/builder.jsx";
import ProductSubscriptionList from "./settings/ProductSubscriptions/index.jsx";
import ProductSubscriptionDetail from "./settings/ProductSubscriptions/ProductDetail.jsx";
import TemplateSmsForm from "./settings/TemplateSms/add.jsx";
import BotsenseConfig from "./settings/botsenseConfig/add.jsx";
import ApiConfigList from "./settings/botsenseConfig/index.jsx"
import TemplateSmsList from "./settings/TemplateSms/index.jsx";
import TemplateResearchManage from "./settings/TemplateResearch/index.jsx";
import TemplateResearchForm from "./settings/TemplateResearch/add.jsx";
import TemplatePortfolioManage from "./settings/TemplatePortfolio/index.jsx";
import TemplatePortfolioForm from "./settings/TemplatePortfolio/add.jsx";
import TemplatePushNotificationForm from "./settings/TemplatePushNotification/add.jsx";
import TemplatePushNotificationList from "./settings/TemplatePushNotification/index.jsx";
import WhatsAppTemplateManager from "./settings/TemplateWhatsappNotification/index.jsx";
import InvestorCharterManagement from "./settings/InvestorCharter/index.jsx";
import InvestorCharterForm from "./settings/InvestorCharter/add.jsx";
import IncentiveRuleForm from "./settings/incentiveRule/add.jsx";
import TicketCategoryPage from "./Ticket/Category/index.jsx";
import TicketCategoryForm from "./Ticket/Category/add.jsx";
import TicketList from "./Ticket/Main/index.jsx";
import TicketDetailsForm from "./Ticket/Main/add.jsx";
import DevTicketList from "./Ticket/DevTicket/index.jsx";
import DevTicketForm from "./Ticket/DevTicket/add.jsx";
import ManageServicesSeo from "./Seo/Service/index.jsx";
import EditServiceSeo from "./Seo/Service/edit.jsx";
import ManagePagesSeo from "./Seo/Page/index.jsx";
import EditPageSeo from "./Seo/Page/edit.jsx";
import ManageServicePages from "./Seo/ServicePages/index.jsx";
import EditServicePage from "./Seo/ServicePages/add.jsx";
import MobilePageManagement from "./mobile/pages/index.jsx";
import PageAdd from "./mobile/pages/add.jsx";
import ContentsPage from "./mobile/Contents/index.jsx";
import MobileContentForm from "./mobile/Contents/add.jsx";
import WorkflowPage from "./workflow/LeadCreation/index.jsx";
import AddLeadCreationStreetFolioForm from "./workflow/LeadCreation/addStreetfolio.jsx";
import AddLeadCreationTradeproForm from "./workflow/LeadCreation/addTradepro.jsx";
import WorkflowSubcriber from "./workflow/Subscriber/index.jsx";
import AddStreetfolioSubscriberForm from "./workflow/Subscriber/addStreetfolioSubscriber.jsx";
import AddTradeproSubscriberForm from "./workflow/Subscriber/addTradeproSubscriber.jsx";
import ViewSubscriberOrder from "./workflow/Subscriber/ViewSubscriberOrder.jsx";
import StreetViewCategory from "./general/StreetViewCategory/index.jsx";
import GeneralCategoryForm from "./general/StreetViewCategory/add.jsx";
import OffersPage from "./general/Offers/index.jsx";
import OfferForm from "./general/Offers/add.jsx";
import ManageTestimonial from "./general/Testimonial/index.jsx";
import TestimonialForm from "./general/Testimonial/add.jsx";
import AskExpertList from "./general/AskExpert/index.jsx";
import AskExpertForm from "./general/AskExpert/add.jsx";
import CustomPagesList from "./general/CustomPages/index.jsx";
import CustomPageForm from "./general/CustomPages/add.jsx";
import EmployeeSalary from "./Payroll/Employee/index.jsx";
import EmployeeSalaryView from "./Payroll/Employee/view.jsx";
import SalaryReport from "./Payroll/SalaryReport/index.jsx";
import PayrollReport from "./Payroll/PayrollReport/index.jsx";
import LeaveManagementApplyList from "./LeaveManagement/ApplyLeave/index.jsx";
import ApplyLeaveForm from "./LeaveManagement/ApplyLeave/add.jsx";
import ManageLeaves from "./LeaveManagement/ManageLeaves/index.jsx";
import ManageLeaveTypes from "./LeaveManagement/LeaveType/index.jsx";
import LeaveTypeForm from "./LeaveManagement/LeaveType/add.jsx";
import ManageNotificationHistory from "./research/NotificationHistory/index.jsx";
import Portfolio from "./research/Portfolio/index.jsx";
import PortfolioEdit from "./research/Portfolio/edit.jsx";
import PortfolioAddPage from "./research/Portfolio/portfolioaddPage.jsx";
import WebsiteServiceForm from "./research/Services/CreditAddPage.jsx";
import ViewMessage from "./research/Portfolio/message.jsx";
import PortfolioDetails from "./research/Portfolio/details.jsx";
import RationaleEdit from "./research/Portfolio/rationale_info.jsx";
// import OrdersPageSattelments from "./OrderSattelments/index.jsx";
import PickupList from "./settings/pickuplist/PickupList.jsx";

import "simplebar-react/dist/simplebar.min.css";
import IncentiveRuleList from "./settings/incentiveRule/index.jsx";
import TemplateWhatsappNotificationForm from "./settings/TemplateWhatsappNotification/add.jsx";
import MediaUploadList from "./settings/mediaUpload/index.jsx";
import AddMediaUpload from "./settings/mediaUpload/add.jsx";
import EditMediaUpload from "./settings/mediaUpload/edit.jsx";
import CreditAdd from "./research/Services/CreditAdd.jsx";
import PortfolipAdd from "./research/Services/PortfolipAdd.jsx";
import HourlyReport from "./research/hourlyReports/HourlyReport.jsx";
import HourlyCommentary from "./research/hourlyCommentry/HourlyCommentary.jsx";
import Symbol from "./research/symbol/Symbol.jsx";
import StreetViewAlerts from "./research/StreetView/StreetViewAlerts.jsx";
import DailyShareview from "./research/performance/DailyShareview.jsx";
import DailyShareviewResult from "./research/performance/DailyShareviewResult.jsx";
import WorkflowSubscription from "./workflow/Subscription/index.jsx";
import AddStreetfolioSubscriptionForm from "./workflow/Subscription/addStreetfolioSubscription.jsx";
import AddTradeproSubscriptionForm from "./workflow/Subscription/addTradeproSubscription.jsx";
import ViewSubscriptionOrder from "./workflow/Subscription/ViewSubscriptionOrder.jsx";
import WorkflowOrder from "./workflow/Order/index.jsx";
import AddStreetfolioOrderForm from "./workflow/Order/addStreetfolioOrder.jsx";
import AddTradeproOrderForm from "./workflow/Order/addTradeproOrder.jsx";
import ViewWorkflowOrder from "./workflow/Order/ViewWorkflowOrder.jsx";
import SubscriptionsEdit from "./Subscriptions/edit.jsx";
import LoginHistory from "./hrms/login-history/index.jsx";
import ESIManagement from "./hrms/esi-management/index.jsx";
import ESIManagementForm from "./hrms/esi-management/add.jsx";
import StaffAttendance from "./hrms/staff-attendance/index.jsx";
import StaffAttendanceForm from "./hrms/staff-attendance/add.jsx";
import EditCustomPage from "./general/CustomPages/edit.jsx";
import MainLayout from "./components/MainLayout.jsx";
import IncomingCallReport from "./Subscriber/IncomingCallReport/index.jsx";
import Payslip from "./Payroll/SalaryReport/downloadPayslip.jsx";
import OrderEdit from "./order/edit.jsx";
import DynamicBlogsList from "./general/DynamicBlogs/index.jsx";
import EditDynemicBlogPage from "./general/DynamicBlogs/edit.jsx";
import WebsiteSitemapList from "./general/WebsiteSitemap/index.jsx";
import AddSitemap from "./general/WebsiteSitemap/add.jsx";
import EditSitemap from "./general/WebsiteSitemap/edit.jsx";
import AddPushNotification from "./research/pushnotification/add.jsx";
import GeneralNotification from "./research/pushnotification/GeneralNotification.jsx";
import IndividualNotification from "./research/pushnotification/IndividualNotification.jsx";
import ViewGeneralNotification from "./research/pushnotification/ViewGeneralNotification.jsx";
import ResearchNotification from "./research/pushnotification/ResearchNotification.jsx";
import ViewResearchNotification from "./research/pushnotification/ViewResearchNotification.js";
import AddFolioPushNotification from "./research/FolioPushNotification/add.jsx";
import FolioGeneralNotification from "./research/FolioPushNotification/GeneralNotification.jsx";
import FolioIndividualNotification from "./research/FolioPushNotification/IndividualNotification.jsx";
import FolioViewGeneralNotification from "./research/FolioPushNotification/ViewGeneralNotification.jsx";
import FolioResearchNotification from "./research/FolioPushNotification/ResearchNotification.jsx";
import FolioViewResearchNotification from "./research/FolioPushNotification/ViewResearchNotification.js";
import SetSalary from "./Payroll/SetSalary/index.js";
import DemoSalary from "./Payroll/SetSalary/demo.js";
import ViewSalaryOrder from "./Payroll/SetSalary/ViewSalaryOrder.js";
import ViewReportOrder from "./Payroll/SetSalary/ViewReportOrder.js";
import EditSalaryReport from "./Payroll/SalaryReport/edit.jsx";
import SendWhatsappBulk from "./research/whatsapp/index.jsx";
import SendEmail from "./research/SendMail/index.jsx";
import SocialSharing from "./research/SocialSharing/index.jsx";
import ChatSg from "./research/ChatSg/index.jsx";
import ChatSf from "./research/ChatSf/index.jsx";
import OrderSettlement from "./OrderSettlement/index.jsx";
import OrderSettlementInfo from "./OrderSettlement/edit.jsx";
import EditStreetView from "./research/StreetView/edit.jsx";
import AnalystViews from "./research/analystView/index.jsx";
import AnalystViewForm from "./research/analystView/add.jsx";
// import EditPerformance from "./research/performance/edit.jsx";
import BulkCampaignList from "./settings/TemplateBulkCampaign/index.jsx";
import AddBulkNotification from "./settings/TemplateBulkCampaign/add.jsx";
import ConfigurationsTemplatesList from "./settings/ConfigurationsTemplates/index.jsx";
import AddConfigurationsTemplate from "./settings/ConfigurationsTemplates/add.jsx";
import BulkCampingReport from "./report/BulkCampingReport/index.jsx";
import CampingDetails from "./report/BulkCampingReport/details.jsx";
import Salary from "./report/SalaryReport/index.jsx";
import InstallationReport from "./report/Installation/index.jsx";
import RevenueReport from "./report/RevenueReport/index.jsx";
import RevenueChart from "./report/RevenueChart/index.jsx";
import SubscriptionReport from "./report/SubscriptionReport/index.jsx";
import DistributorReport from "./report/DistributorReport/index.jsx";
import DistributorReportDetail from "./report/DistributorReport/DistributorReportDetail.jsx";
import AdsReport from "./report/AdsReport/index.jsx";
import AdsReportDetail from "./report/AdsReport/AdsReportDetail.jsx";
import AdsCampaignUpdate from "./report/AdsReport/AdsCampaignUpdate.jsx";
import SubscriberStatusReport from "./report/SubscriberStatusReport/index.jsx";
import CallSummaryReport from "./report/CallSummaryReport/index.jsx";
import EmailStatisticsReport from "./report/EmailStatisticsReport/index.jsx";
import WhatsappReport from "./report/WhatsappReport/index.jsx";
import WhatsappOptinReport from "./report/WhatsappOptinReport/index.jsx";
import SubscriberDataReport from "./report/SubscriberDataReport/index.jsx";
import EmailEventLogsReport from "./report/EmailEventLogsReport/index.jsx";
import LinkTrackingReport from "./report/LinkTrackingReport/index.jsx";
import UtmLinks from "./utmLinks/index.jsx";
import AddUtmLink from "./utmLinks/add.jsx";
import LeadSourceReport from "./report/LeadSourceReport/index.jsx";
import SubscriberAnalysisChart from "./report/SubscriberAnalysisChart/index.jsx";
import ManageLeadSourceCost from "./report/LeadSourceCost/index.jsx";
import LeadSourceCostForm from "./report/LeadSourceCost/add.jsx";
import SubscriptionAnalysisReport from "./report/SubscriptionAnalysisReport/index.jsx";
import SubscriberAnalysisReport from "./report/SubscriberAnalysisReport/index.jsx";
import SubscriptionAnalysisChart from "./report/SubscriptionAnalysisChart/index.jsx";
import TwitterDailyPost from "./report/Twitter/index.jsx";
import WebsiteReviews from "./general/WebsiteReviews/index.jsx";
import WebsiteReviewsForm from "./general/WebsiteReviews/add.jsx";
import SingleCampaignReport from "./report/SingleCampingReport/index.jsx";
import SingleCampingDetails from "./report/SingleCampingReport/details.jsx";
import BotSenseChat from "./components/BotSenseChat.js";
import PrivateRoute from "./components/PrivateRoute.jsx"; // Import the PrivateRoute component
import BroadcastReport from "./report/BrodCastReport/index.jsx";
import BroadcastDetails from "./report/BrodCastReport/details.jsx";
import Freshdesk from "./components/freshdesk.jsx";
import setupAxiosInterceptors from "./helpers/axiosInterceptor";
import ExecutivePerformanceReport from "./report/ExecutivePerformanceReport/index.jsx";
import MailboxPage from "./email/pages/MailboxPage.jsx";
import { whatsappChatRoutes } from "./whatsappChat/routes.jsx";

// Streetlearn
import StreetlearnLearners from "./streetlearn/learners/index.jsx";
import StreetlearnLearnerDetail from "./streetlearn/learners/view.jsx";
import StreetlearnOrders from "./streetlearn/orders/index.jsx";
import StreetlearnCertificates from "./streetlearn/certificates/index.jsx";
import StreetlearnAnalytics from "./streetlearn/analytics/index.jsx";
import StreetlearnQuestions from "./streetlearn/questions/index.jsx";
import StreetlearnExamSettings from "./streetlearn/examSettings/index.jsx";
import StreetlearnCurriculum from "./streetlearn/curriculum/index.jsx";
import LessonStudio from "./streetlearn/curriculum/LessonStudio.jsx";


const ServiceReportWrapper = () => {
  const { serviceId } = useParams();
  return <ServiceReport serviceId={serviceId} />;
};

const App = () => {

  useEffect(() => {
    setupAxiosInterceptors();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Login route */}
        <Route path="/login" element={<Login />} />

        {/* Content Area */}
        <Route path="/" element={<MainLayout />}>
          <Route
            path="/dashboard"
            element={<PrivateRoute element={<Dashboard />} />}
          />
          <Route
            path="/email"
            element={
              <PrivateRoute
                module="email"
                action="view"
                element={<MailboxPage />}
              />
            }
          />
          <Route
            path="/mail"
            element={
              <PrivateRoute
                module="email"
                action="view"
                element={<MailboxPage />}
              />
            }
          />
          <Route
            path="/service-report/:serviceId"
            element={<PrivateRoute element={<ServiceReportWrapper />} />}
          />
          <Route
            path="/my-dashboard"
            element={<PrivateRoute element={<MyDashboard />} />}
          />
          <Route
            path="/distributor-dashboard"
            element={
              <PrivateRoute
                module="distributor_dashboard"
                action="view"
                element={<DistributorDashboard />}
              />
            }
          />
          {whatsappChatRoutes}
          <Route
            path="/botsense-chat"
            element={<PrivateRoute element={<BotSenseChat />} />}
          />
          <Route
            path="/freshdesk"
            element={<PrivateRoute element={<Freshdesk />} />}
          />
          <Route
            path="/Hrms/Role"
            element={
              <PrivateRoute
                module="hrms_role"
                action="view"
                element={<RoleManager />}
              />
            }
          />
          <Route
            path="/Hrms/Role/add"
            element={
              <PrivateRoute
                module="hrms_role"
                action="add"
                element={<AddRole />}
              />
            }
          />
          <Route
            path="/Hrms/Role/edit/:id"
            element={
              <PrivateRoute
                module="hrms_role"
                action="edit"
                element={<AddRole />}
              />
            }
          />
          <Route
            path="/Hrms/Role/addUserRole/:id"
            element={
              <PrivateRoute
                module="hrms_role"
                action="add"
                element={<AddUserRole />}
              />
            }
          />
          <Route
            path="/Hrms/User"
            element={
              <PrivateRoute
                module="hrms_user"
                action="view"
                element={<UserManagement />}
              />
            }
          />
          <Route
            path="/Hrms/User/add"
            element={
              <PrivateRoute
                module="hrms_user"
                action="add"
                element={<AddUser />}
              />
            }
          />
          <Route
            path="/Hrms/User/edit/:id"
            element={
              <PrivateRoute
                module="hrms_user"
                action="edit"
                element={<AddUser />}
              />
            }
          />
          <Route
            path="/Hrms/User/addSubuser/:id"
            element={
              <PrivateRoute
                module="hrms_user"
                action="edit"
                element={<AddSubuser />}
              />
            }
          />
          <Route
            path="/Hrms/DistributorUser"
            element={
              <PrivateRoute
                module="hrms_distributor_user"
                action="view"
                element={<DistributorUserManagement />}
              />
            }
          />
          <Route
            path="/Hrms/DistributorUser/add"
            element={
              <PrivateRoute
                module="hrms_distributor_user"
                action="add"
                element={<AddDistributorUser />}
              />
            }
          />
          <Route
            path="/Hrms/DistributorUser/edit/:id"
            element={
              <PrivateRoute
                module="hrms_distributor_user"
                action="edit"
                element={<AddDistributorUser />}
              />
            }
          />
          <Route
            path="/Hrms/DistributorUser/addSubuser/:id"
            element={
              <PrivateRoute
                module="hrms_distributor_user"
                action="edit"
                element={<AddDistributorSubuser />}
              />
            }
          />
          <Route
            path="/Hrms/EsiManagement"
            element={
              <PrivateRoute
                module="hrms_esimgmt"
                action="view"
                element={<ESIManagement />}
              />
            }
          />
          <Route
            path="/Hrms/EsiManagement/edit/:id"
            element={
              <PrivateRoute
                module="hrms_esimgmt"
                action="edit"
                element={<ESIManagementForm />}
              />
            }
          />
          <Route
            path="/Hrms/LoginHistory"
            element={
              <PrivateRoute
                module="hrms_history"
                action="view"
                element={<LoginHistory />}
              />
            }
          />
          <Route
            path="/Hrms/StaffAttendance"
            element={
              <PrivateRoute
                module="hrms_staff_attendance"
                action="view"
                element={<StaffAttendance />}
              />
            }
          />
          <Route
            path="/Hrms/StaffAttendance/edit/:id"
            element={
              <PrivateRoute
                module="hrms_staff_attendance"
                action="edit"
                element={<StaffAttendanceForm />}
              />
            }
          />
          <Route
            path="/profile"
            element={<PrivateRoute element={<Profile />} />}
          />
          <Route
            path="/profile/:id"
            element={<PrivateRoute element={<Profile />} />}
          />
          <Route
            path="/profile/change-password"
            element={<PrivateRoute element={<ChangePassword />} />}
          />
          <Route
            path="/profile/edit-profile"
            element={<PrivateRoute element={<EditProfile />} />}
          />
          <Route
            path="/research/markets"
            element={<PrivateRoute element={<Markets />} />}
          />
          <Route
            path="/research/patterns-radar"
            element={
              <PrivateRoute
                module="patterns_radar"
                action="view"
                element={<PatternsRadar />}
              />
            }
          />
          <Route
            path="/research/patterns-radar/symbol/:symbol"
            element={
              <PrivateRoute
                module="patterns_radar"
                action="view"
                element={<PatternsRadarSymbolDetail />}
              />
            }
          />
          <Route
            path="/research/careparrva-output"
            element={
              <PrivateRoute
                module="careparrva_output"
                action="view"
                element={<CareparrvaOutput />}
              />
            }
          />
          <Route
            path="/research/careparrva-output/view/:id"
            element={
              <PrivateRoute
                module="careparrva_output"
                action="view"
                element={<CareparrvaReportDetail />}
              />
            }
          />
          <Route
            path="/research/carparava-output"
            element={
              <PrivateRoute
                module="careparrva_output"
                action="view"
                element={<CareparrvaOutput />}
              />
            }
          />
          <Route
            path="/research/markets/hourly/report"
            element={<PrivateRoute element={<HourlyReport />} />}
          />
          <Route
            path="/research/markets/hourly/commentary"
            element={<PrivateRoute element={<HourlyCommentary />} />}
          />
          <Route
            path="/research/notifications/add"
            element={
              <PrivateRoute
                module="notification"
                action="add"
                element={<AddNotifications />}
              />
            }
          />
          <Route
            path="/research/notifications/edit/:id"
            element={
              <PrivateRoute
                module="notification"
                action="edit"
                element={<AddNotifications />}
              />
            }
          />
          <Route
            path="/research/notifications"
            element={
              <PrivateRoute
                module="notification"
                action="view"
                element={<Notifications />}
              />
            }
          />
          {/* Angel Notifications disabled - not required
          <Route
            path="/research/angel-notifications/add"
            element={
              <PrivateRoute
                module="angel_notification"
                action="add"
                element={<AddAngelNotifications />}
              />
            }
          />
          <Route
            path="/research/angel-notifications/edit/:id"
            element={
              <PrivateRoute
                module="angel_notification"
                action="edit"
                element={<AddAngelNotifications />}
              />
            }
          />
          <Route
            path="/research/angel-notifications"
            element={
              <PrivateRoute
                module="angel_notification"
                action="view"
                element={<AngelNotifications />}
              />
            }
          />
          <Route
            path="/research/angelNotification/add"
            element={
              <PrivateRoute
                module="notification"
                action="add"
                element={<AddAngelNotifications />}
              />
            }
          />
          <Route
            path="/research/angelNotification/edit/:id"
            element={
              <PrivateRoute
                module="notification"
                action="edit"
                element={<AddAngelNotifications />}
              />
            }
          />
          <Route
            path="/research/angelNotification"
            element={
              <PrivateRoute
                module="notification"
                action="view"
                element={<AngelNotifications />}
              />
            }
          />
          */}
          <Route
            path="/research/watchlist"
            element={<PrivateRoute element={<Watchlist />} />}
          />
          <Route
            path="/research/Portfolio"
            element={
              <PrivateRoute
                module="portfolio"
                action="view"
                element={<Portfolio />}
              />
            }
          />
          <Route
            path="/research/Portfolio/edit/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="edit"
                element={<PortfolioEdit />}
              />
            }
          />
          <Route
            path="/research/Portfolio/rationaleinfo/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="view"
                element={<RationaleEdit />}
              />
            }
          />
          <Route
            path="/research/PortfolioaddPage/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="edit"
                element={<PortfolioAddPage />}
              />
            }
          />
          <Route
            path="/research/Services/credit/:id"
            element={
              <PrivateRoute
                module="services"
                action="view"
                element={<WebsiteServiceForm />}
              />
            }
          />
          <Route
            path="/research/Portfolio/message/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="view"
                element={<ViewMessage />}
              />
            }
          />
          <Route
            path="/research/Portfolio/details/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="add"
                element={<PortfolioDetails />}
              />
            }
          />
          <Route
            path="/Research/NotificationHistory"
            element={
              <PrivateRoute
                module="notificationhistory"
                action="view"
                element={<ManageNotificationHistory />}
              />
            }
          />
          <Route
            path="/research/performance"
            element={
              <PrivateRoute
                module="performance"
                action="view"
                element={<Performance />}
              />
            }
          />
          <Route
            path="/research/performance/edit/:id"
            element={
              <PrivateRoute
                module="performance"
                action="edit"
                element={<EditPerformance />}
              />
            }
          />
          <Route
            path="/research/performance/shareview"
            element={
              <PrivateRoute
                module="performance"
                action="view"
                element={<Shareview />}
              />
            }
          />
          <Route
            path="/research/performance/dailyshareview"
            element={
              <PrivateRoute
                module="performance"
                action="view"
                element={<DailyShareview />}
              />
            }
          />
          <Route
            path="/research/performance/dailyshareviewresult"
            element={
              <PrivateRoute
                module="performance"
                action="view"
                element={<DailyShareviewResult />}
              />
            }
          />
          <Route
            path="/research/streetstocks"
            element={<PrivateRoute element={<StreetStocks />} />}
          />
          <Route
            path="/research/streetstocks/view/:id"
            element={<PrivateRoute element={<ViewHistory />} />}
          />
          <Route
            path="/research/Services"
            element={
              <PrivateRoute
                odule="services"
                action="view"
                element={<Services />}
              />
            }
          />
          <Route
            path="/research/Services/credit/add"
            element={
              <PrivateRoute
                odule="services"
                action="add"
                element={<CreditAdd />}
              />
            }
          />
          <Route
            path="/research/Services/portfolio/add"
            element={
              <PrivateRoute
                module="portfolio"
                action="add"
                element={<PortfolipAdd />}
              />
            }
          />
          <Route
            path="/research/Services/credit/edit/:id"
            element={
              <PrivateRoute
                module="services"
                action="edit"
                element={<CreditAdd />}
              />
            }
          />
          <Route
            path="/research/Services/portfolio/edit/:id"
            element={
              <PrivateRoute
                module="portfolio"
                action="edit"
                element={<PortfolipAdd />}
              />
            }
          />
          <Route
            path="/research/Symbol"
            element={
              <PrivateRoute
                module="symbols"
                action="view"
                element={<Symbol />}
              />
            }
          />
          <Route
            path="/research/segment"
            element={
              <PrivateRoute
                module="services"
                action="view"
                element={<SegmentManage />}
              />
            }
          />
          <Route
            path="/research/segment/add"
            element={
              <PrivateRoute
                module="services"
                action="add"
                element={<SegmentForm />}
              />
            }
          />
          <Route
            path="/research/segment/edit/:id"
            element={
              <PrivateRoute
                module="services"
                action="edit"
                element={<SegmentForm />}
              />
            }
          />
          <Route
            path="/research/streetview"
            element={
              <PrivateRoute
                module="streetview"
                action="view"
                element={<StreetViewAlerts />}
              />
            }
          />
          <Route
            path="research/StreetView/edit/:id"
            element={
              <PrivateRoute
                module="streetview"
                action="edit"
                element={<EditStreetView />}
              />
            }
          />
          <Route
            path="research/analystView"
            element={
              <PrivateRoute
                module="analystView"
                action="view"
                element={<AnalystViews />}
              />
            }
          />
          <Route
            path="research/analystView/add"
            element={
              <PrivateRoute
                module="analystView"
                action="add"
                element={<AnalystViewForm />}
              />
            }
          />
          <Route
            path="research/analystView/edit/:id"
            element={
              <PrivateRoute
                module="analystView"
                action="edit"
                element={<AnalystViewForm />}
              />
            }
          />
          <Route
            path="Campaign/PushNotification"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<AddPushNotification />}
              />
            }
          />
          <Route
            path="Campaign/GeneralNotification"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<GeneralNotification />}
              />
            }
          />
          <Route
            path="Campaign/IndividualNotification"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<IndividualNotification />}
              />
            }
          />
          <Route
            path="/Campaign/GeneralNotification/View/:id"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<ViewGeneralNotification />}
              />
            }
          />
          <Route
            path="/Campaign/ResearchNotification"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<ResearchNotification />}
              />
            }
          />
          <Route
            path="/Campaign/ResearchNotification/view/:id"
            element={
              <PrivateRoute
                module="pushnotifications"
                action="view"
                element={<ViewResearchNotification />}
              />
            }
          />
          <Route
            path="Campaign/FolioPushNotification/sf"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<AddFolioPushNotification />}
              />
            }
          />
          <Route
            path="Campaign/FolioGeneralNotification"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<FolioGeneralNotification />}
              />
            }
          />
          <Route
            path="Campaign/FolioIndividualNotification"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<FolioIndividualNotification />}
              />
            }
          />
          <Route
            path="/Campaign/FolioGeneralNotification/view/:id"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<FolioViewGeneralNotification />}
              />
            }
          />
          <Route
            path="/Campaign/FolioResearchNotification"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<FolioResearchNotification />}
              />
            }
          />
          <Route
            path="/Campaign/FolioResearchNotification/view/:id"
            element={
              <PrivateRoute
                module="folio_pushnotifications"
                action="view"
                element={<FolioViewResearchNotification />}
              />
            }
          />
          <Route
            path="/Subscriber"
            element={
              <PrivateRoute
                module="subscriber"
                action="view"
                element={<Subscriber />}
              />
            }
          />
          <Route
            path="/AICallCampaigns"
            element={
              <PrivateRoute
                module="ai_voice_calling"
                action="view"
                element={<AICallDashboard />}
              />
            }
          />
          <Route
            path="/AISarvamVoiceCalling"
            element={
              <PrivateRoute
                module="sarvam_ai_call_campaign"
                action="view"
                element={<SarvamVoiceDashboard />}
              />
            }
          />

          <Route
            path="/Subscriber/Edit/:id"
            element={
              <PrivateRoute
                module="subscriber"
                action="view"
                element={<SubscriberEdit />}
              />
            }
          />
          <Route
            path="/SubscriberPortfolio"
            element={
              <PrivateRoute
                module="subscriber_portfolio"
                action="view"
                element={<SubscriberPortfolio />}
              />
            }
          />
          <Route
            path="/Report/callSummary"
            element={
              <PrivateRoute
                module="subscriber"
                action="view"
                element={<IncomingCallReport />}
              />
            }
          />
          <Route
            path="/SubscriberPortfolio"
            element={
              <PrivateRoute
                module="subscriber_portfolio"
                action="view"
                element={<SubscriberPortfolio />}
              />
            }
          />
          <Route
            path="/Subscriber/Portfolio"
            element={
              <PrivateRoute
                module="subscriber_portfolio"
                action="view"
                element={<SubscriberPortfolio />}
              />
            }
          />
          <Route
            path="/Subscription"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<Subscription />}
              />
            }
          />
          <Route
            path="/Subscription/Edit/:id"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<SubscriptionsEdit />}
              />
            }
          />
          <Route
            path="/SubscriptionPortfolio"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<SubscriptionPortfolio />}
              />
            }
          />
          <Route
            path="/SubscriptionPortfolio/Edit/:id"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<SubscriptionPortfolioEdit />}
              />
            }
          />
          <Route
            path="/SubscriptionCredits"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<SubscriptionCredits />}
              />
            }
          />
          <Route
            path="/SubscriptionCredits/Edit/:id"
            element={
              <PrivateRoute
                module="subscription"
                action="view"
                element={<SubscriptionCreditsEdit />}
              />
            }
          />
          <Route
            path="/Order"
            element={
              <PrivateRoute module="orders" action="view" element={<Order />} />
            }
          />
          <Route
            path="/Order/Edit/:id"
            element={
              <PrivateRoute
                module="orders"
                action="view"
                element={<OrderEdit />}
              />
            }
          />
          {/* <Route path="/Orders/settlements" element={<PrivateRoute element={<OrdersPageSattelments />} />} /> */}
          <Route
            path="/Settings/Company"
            element={
              <PrivateRoute
                module="settings_company"
                action="view"
                element={<CompanyProfile />}
              />
            }
          />
          <Route
            path="/Settings/Company/edit"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<CompanyEditForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/editConfigs"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<ConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/editPrintConfigs"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<PrintConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/testNotification"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<TestNotifixation />}
              />
            }
          />
          <Route
            path="/profile/Payslip"
            element={<PrivateRoute element={<DownloadPayslip />} />}
          />
          <Route
            path="/Settings/Company/editOffer"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<CompanyOfferForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/editCallConfigs"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<CallConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/editWhatsappConfigs"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<WhatsappConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/carparvaLogin"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<CarparvaLoginForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/carparvaOutputLogin"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<CarparvaOutputLoginForm />}
              />
            }
          />
          <Route
            path="/Settings/Company/philosophyVideo"
            element={
              <PrivateRoute
                module="settings_company"
                action="edit"
                element={<PhilosophyVideoForm />}
              />
            }
          />
          <Route
            path="/Settings/AiCallingPrompts"
            element={
              <PrivateRoute
                module="settings_ai_prompts"
                action="view"
                element={<AiCallingPrompts />}
              />
            }
          />
          <Route
            path="/Settings/AiCallingPrompts/add"
            element={
              <PrivateRoute
                module="settings_ai_prompts"
                action="add"
                element={<AiCallingPromptForm />}
              />
            }
          />
          <Route
            path="/Settings/AiCallingPrompts/edit/:id"
            element={
              <PrivateRoute
                module="settings_ai_prompts"
                action="edit"
                element={<AiCallingPromptForm />}
              />
            }
          />
          <Route
            path="/Settings/EmailConfig"
            element={
              <PrivateRoute
                module="settings_emailconfig"
                action="view"
                element={<EmailConfigManagement />}
              />
            }
          />
          <Route
            path="/Settings/EmailConfig/add"
            element={
              <PrivateRoute
                module="settings_emailconfig"
                action="add"
                element={<AddEmailConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/EmailConfig/edit/:id"
            element={
              <PrivateRoute
                module="settings_emailconfig"
                action="edit"
                element={<AddEmailConfigForm />}
              />
            }
          />
          <Route
            path="/Settings/EmailMapping"
            element={
              <PrivateRoute
                module="settings_mapping"
                action="view"
                element={<EmailMapping />}
              />
            }
          />
          <Route
            path="/Settings/EmailMapping/add"
            element={
              <PrivateRoute
                module="settings_mapping"
                action="add"
                element={<EmailMappingForm />}
              />
            }
          />
          <Route
            path="/Settings/EmailMapping/edit/:id"
            element={
              <PrivateRoute
                module="settings_mapping"
                action="edit"
                element={<EmailMappingForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateLetter"
            element={
              <PrivateRoute
                module="settings_letter"
                action="view"
                element={<TemplateLetterPage />}
              />
            }
          />
          <Route
            path="/Settings/TemplateLetter/add"
            element={
              <PrivateRoute
                module="settings_letter"
                action="add"
                element={<TemplateLetterForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateEmail"
            element={
              <PrivateRoute
                module="settings_email"
                action="view"
                element={<TemplateEmailList />}
              />
            }
          />
          <Route
            path="/Settings/TemplateEmail/add"
            element={
              <PrivateRoute
                module="settings_email"
                action="add"
                element={<TemplateEmailForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateEmail/edit/:id"
            element={
              <PrivateRoute
                module="settings_email"
                action="edit"
                element={<TemplateEmailForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateEmail/html-edit/:id"
            element={
              <PrivateRoute
                module="settings_email"
                action="edit"
                element={<TemplateEmailHtmlEdit />}
              />
            }
          />
          <Route
            path="/Settings/TemplateBuilder"
            element={
              <PrivateRoute
                module="settings_templatebuilder"
                action="view"
                element={<TemplateBuilderList />}
              />
            }
          />
          <Route
            path="/Settings/TemplateBuilder/add"
            element={
              <PrivateRoute
                module="settings_templatebuilder"
                action="add"
                element={<TemplateBuilderEditor />}
              />
            }
          />
          <Route
            path="/Settings/TemplateBuilder/edit/:id"
            element={
              <PrivateRoute
                module="settings_templatebuilder"
                action="edit"
                element={<TemplateBuilderEditor />}
              />
            }
          />
          <Route
            path="/Settings/ProductSubscriptions"
            element={
              <PrivateRoute
                module="settings_product_subscriptions"
                action="view"
                element={<ProductSubscriptionList />}
              />
            }
          />
          <Route
            path="/Settings/ProductSubscriptions/:id"
            element={
              <PrivateRoute
                module="settings_product_subscriptions"
                action="view"
                element={<ProductSubscriptionDetail />}
              />
            }
          />
          <Route
            path="/research/ProductSubscriptions"
            element={
              <PrivateRoute
                module="settings_product_subscriptions"
                action="view"
                element={<ProductSubscriptionList />}
              />
            }
          />
          <Route
            path="/research/ProductSubscriptions/:id"
            element={
              <PrivateRoute
                module="settings_product_subscriptions"
                action="view"
                element={<ProductSubscriptionDetail />}
              />
            }
          />
          <Route
            path="/Settings/TemplateSms"
            element={
              <PrivateRoute
                module="settings_sms"
                action="view"
                element={<TemplateSmsList />}
              />
            }
          />
          <Route
            path="/Settings/TemplateSms/add"
            element={
              <PrivateRoute
                module="settings_sms"
                action="add"
                element={<TemplateSmsForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateSms/edit/:id"
            element={
              <PrivateRoute
                module="settings_sms"
                action="edit"
                element={<TemplateSmsForm />}
              />
            }
          />
          <Route
            path="/Settings/apiconfig"
            element={
              <PrivateRoute
                module="settings_apiconfig"
                action="view"
                element={<ApiConfigList />}
              />
            }
          />
          <Route
            path="/api-config/add"
            element={
              <PrivateRoute
                module="settings_botsenseconfig"
                action="view"
                element={<BotsenseConfig />}
              />
            }
          />
          <Route
            path="/api-config/edit/:id"
            element={
              <PrivateRoute
                module="settings_apiconfig"
                action="edit"
                element={<BotsenseConfig />}
              />
            }
          />
          <Route
            path="/Settings/TemplateResearch"
            element={
              <PrivateRoute
                module="settings_researchsms"
                action="view"
                element={<TemplateResearchManage />}
              />
            }
          />
          <Route
            path="/Settings/MediaUpload"
            element={
              <PrivateRoute
                module="settings_media_upload"
                action="view"
                element={<MediaUploadList />}
              />
            }
          />
          <Route
            path="/Settings/MediaUpload/add"
            element={
              <PrivateRoute
                module="settings_media_upload"
                action="add"
                element={<AddMediaUpload />}
              />
            }
          />
          <Route
            path="/Settings/MediaUpload/edit/:id"
            element={
              <PrivateRoute
                module="settings_media_upload"
                action="edit"
                element={<EditMediaUpload />}
              />
            }
          />
          <Route
            path="/Settings/TemplateResearch/add"
            element={
              <PrivateRoute
                module="settings_researchsms"
                action="add"
                element={<TemplateResearchForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateResearch/edit/:id"
            element={
              <PrivateRoute
                module="settings_researchsms"
                action="edit"
                element={<TemplateResearchForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplatePortfolio"
            element={<PrivateRoute element={<TemplatePortfolioManage />} />}
          />
          <Route
            path="/Settings/TemplatePortfolio/add"
            element={<PrivateRoute element={<TemplatePortfolioForm />} />}
          />
          <Route
            path="/Settings/TemplatePortfolio/edit/:id"
            element={<PrivateRoute element={<TemplatePortfolioForm />} />}
          />
          <Route
            path="/Settings/TemplatePushNotification"
            element={
              <PrivateRoute
                module="settings_pushnotification"
                action="view"
                element={<TemplatePushNotificationList />}
              />
            }
          />
          <Route
            path="/Settings/TemplatePushNotification/add"
            element={
              <PrivateRoute
                module="settings_pushnotification"
                action="add"
                element={<TemplatePushNotificationForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplatePushNotification/edit/:id"
            element={
              <PrivateRoute
                module="settings_pushnotification"
                action="edit"
                element={<TemplatePushNotificationForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateWhatsappNotification"
            element={
              <PrivateRoute
                module="settings_whatsappnotification"
                action="view"
                element={<WhatsAppTemplateManager />}
              />
            }
          />
          <Route
            path="/Settings/TemplateWhatsappNotification/add"
            element={
              <PrivateRoute
                module="settings_whatsappnotification"
                action="add"
                element={<TemplateWhatsappNotificationForm />}
              />
            }
          />
          <Route
            path="/Settings/TemplateWhatsappNotification/edit/:id"
            element={
              <PrivateRoute
                module="settings_whatsappnotification"
                action="edit"
                element={<TemplateWhatsappNotificationForm />}
              />
            }
          />
          <Route
            path="/Settings/Pickuplist/crm"
            element={
              <PrivateRoute
                module="settings_pickuplist"
                action="view"
                element={<PickupList />}
              />
            }
          />
          <Route
            path="Settings/InvestorCharter"
            element={
              <PrivateRoute
                module="settings_investorcharter"
                action="view"
                element={<InvestorCharterManagement />}
              />
            }
          />
          <Route
            path="Settings/InvestorCharter/add"
            element={
              <PrivateRoute
                module="settings_investorcharter"
                action="add"
                element={<InvestorCharterForm />}
              />
            }
          />
          <Route
            path="Settings/InvestorCharter/edit/:id"
            element={
              <PrivateRoute
                module="settings_investorcharter"
                action="edit"
                element={<InvestorCharterForm />}
              />
            }
          />
          <Route
            path="Settings/IncentiveRule"
            element={
              <PrivateRoute
                module="settings_incentiverule"
                action="view"
                element={<IncentiveRuleList />}
              />
            }
          />
          <Route
            path="Settings/IncentiveRule/add"
            element={
              <PrivateRoute
                module="settings_incentiverule"
                action="add"
                element={<IncentiveRuleForm />}
              />
            }
          />
          <Route
            path="Settings/IncentiveRule/edit/:id"
            element={
              <PrivateRoute
                module="settings_incentiverule"
                action="edit"
                element={<IncentiveRuleForm />}
              />
            }
          />
          <Route
            path="Settings/TemplateBulkCampaign"
            element={
              <PrivateRoute
                module="settings_bulkCampaign"
                action="view"
                element={<BulkCampaignList />}
              />
            }
          />
          <Route
            path="Settings/TemplateBulkCampaign/add"
            element={
              <PrivateRoute
                module="settings_bulkCampaign"
                action="add"
                element={<AddBulkNotification />}
              />
            }
          />
          <Route
            path="Settings/TemplateBulkCampaign/edit/:id"
            element={
              <PrivateRoute
                module="settings_bulkCampaign"
                action="edit"
                element={<AddBulkNotification />}
              />
            }
          />
          {/* Configurations Templates */}
          <Route
            path="Settings/ConfigurationsTemplates"
            element={
              <PrivateRoute
                module="settings_configurations_templates"
                action="view"
                element={<ConfigurationsTemplatesList />}
              />
            }
          />
          <Route
            path="Settings/ConfigurationsTemplates/add"
            element={
              <PrivateRoute
                module="settings_configurations_templates"
                action="add"
                element={<AddConfigurationsTemplate />}
              />
            }
          />
          <Route
            path="Settings/ConfigurationsTemplates/edit/:id"
            element={
              <PrivateRoute
                module="settings_configurations_templates"
                action="edit"
                element={<AddConfigurationsTemplate />}
              />
            }
          />
          {/* Tickets Module */}
          <Route
            path="Ticket/Category"
            element={
              <PrivateRoute
                module="ticket_category"
                action="view"
                element={<TicketCategoryPage />}
              />
            }
          />
          <Route
            path="Ticket/Category/add"
            element={
              <PrivateRoute
                module="ticket_category"
                action="add"
                element={<TicketCategoryForm />}
              />
            }
          />
          <Route
            path="Ticket/Category/edit/:id"
            element={
              <PrivateRoute
                module="ticket_category"
                action="edit"
                element={<TicketCategoryForm />}
              />
            }
          />
          <Route
            path="Ticket/Main/tickets/:catid"
            element={
              <PrivateRoute
                module="ticket_listing"
                action="view"
                element={<TicketList />}
              />
            }
          />
          <Route
            path="Ticket/Main/tickets/:catid/add"
            element={
              <PrivateRoute
                module="ticket_listing"
                action="add"
                element={<TicketDetailsForm />}
              />
            }
          />
          <Route
            path="Ticket/Main/tickets/:catid/edit/:id"
            element={
              <PrivateRoute
                module="ticket_listing"
                action="edit"
                element={<TicketDetailsForm />}
              />
            }
          />
          <Route
            path="DevTicket/Ticket"
            element={
              <PrivateRoute
                module="dev_ticket_listing"
                action="view"
                element={<DevTicketList />}
              />
            }
          />
          <Route
            path="DevTicket/Ticket/add"
            element={
              <PrivateRoute
                module="dev_ticket_listing"
                action="add"
                element={<DevTicketForm />}
              />
            }
          />
          <Route
            path="DevTicket/Ticket/edit/:id"
            element={
              <PrivateRoute
                module="dev_ticket_listing"
                action="edit"
                element={<DevTicketForm />}
              />
            }
          />
          {/* Seo Module */}
          <Route
            path="Seo/Services"
            element={
              <PrivateRoute
                module="seo_portfolio"
                action="view"
                element={<ManageServicesSeo />}
              />
            }
          />
          <Route
            path="Seo/Services/edit/:id"
            element={
              <PrivateRoute
                module="seo_portfolio"
                action="edit"
                element={<EditServiceSeo />}
              />
            }
          />
          <Route
            path="Seo/Pages"
            element={
              <PrivateRoute
                module="seo_pages"
                action="view"
                element={<ManagePagesSeo />}
              />
            }
          />
          <Route
            path="Seo/Pages/edit/:id"
            element={
              <PrivateRoute
                module="seo_pages"
                action="edit"
                element={<EditPageSeo />}
              />
            }
          />
          <Route
            path="Seo/ServicePages"
            element={
              <PrivateRoute
                module="extra_pages"
                action="view"
                element={<ManageServicePages />}
              />
            }
          />
          <Route
            path="Seo/ServicePages/add"
            element={
              <PrivateRoute
                module="extra_pages"
                action="add"
                element={<EditServicePage />}
              />
            }
          />
          <Route
            path="Seo/ServicePages/edit/:id"
            element={
              <PrivateRoute
                module="extra_pages"
                action="edit"
                element={<EditServicePage />}
              />
            }
          />
          {/* Mobile */}
          <Route
            path="Website/Pages"
            element={<PrivateRoute element={<MobilePageManagement />} />}
          />
          <Route
            path="Website/Pages/add"
            element={<PrivateRoute element={<PageAdd />} />}
          />
          <Route
            path="Website/Contents/list/home"
            element={<PrivateRoute element={<ContentsPage />} />}
          />
          <Route
            path="Website/Contents/list/home/add"
            element={<PrivateRoute element={<MobileContentForm />} />}
          />
          {/* Workflow */}
          <Route
            path="Workflow/LeadCreation"
            element={
              <PrivateRoute
                module="workflow_lead"
                action="view"
                element={<WorkflowPage />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/LeadCreation/add"
            element={
              <PrivateRoute
                module="workflow_lead"
                action="add"
                element={<AddLeadCreationTradeproForm />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/LeadCreation/edit/:id"
            element={
              <PrivateRoute
                module="workflow_lead"
                action="edit"
                element={<AddLeadCreationTradeproForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/LeadCreation/add"
            element={
              <PrivateRoute
                module="workflow_lead"
                action="add"
                element={<AddLeadCreationStreetFolioForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/LeadCreation/edit/:id"
            element={
              <PrivateRoute
                module="workflow_lead"
                action="edit"
                element={<AddLeadCreationStreetFolioForm />}
              />
            }
          />
          <Route
            path="Workflow/Subscriber"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="view"
                element={<WorkflowSubcriber />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Subscriber/add"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="add"
                element={<AddTradeproSubscriberForm />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Subscriber/edit/:id"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="edit"
                element={<AddTradeproSubscriberForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscriber/add"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="add"
                element={<AddStreetfolioSubscriberForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscriber/edit/:id"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="edit"
                element={<AddStreetfolioSubscriberForm />}
              />
            }
          />
          <Route
            path="Workflow/Subscriber/view"
            element={
              <PrivateRoute
                module="workflow_subscriber"
                action="view"
                element={<ViewSubscriberOrder />}
              />
            }
          />
          <Route
            path="Workflow/Subscription"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="view"
                element={<WorkflowSubscription />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Subscription/add"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="add"
                element={<AddTradeproSubscriptionForm />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Subscription/edit/:id"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="edit"
                element={<AddTradeproSubscriptionForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscription/add"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="add"
                element={<AddStreetfolioSubscriptionForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscription/edit/:id"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="edit"
                element={<AddStreetfolioSubscriptionForm />}
              />
            }
          />
          <Route
            path="Workflow/Subscription/view"
            element={
              <PrivateRoute
                module="workflow_subscription"
                action="view"
                element={<ViewSubscriptionOrder />}
              />
            }
          />
          <Route
            path="Workflow/Order"
            element={
              <PrivateRoute
                module="workflow_order"
                action="view"
                element={<WorkflowOrder />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Order/add"
            element={
              <PrivateRoute
                module="workflow_order"
                action="add"
                element={<AddTradeproOrderForm />}
              />
            }
          />
          <Route
            path="WorkflowTradepro/Order/edit/:id"
            element={
              <PrivateRoute
                module="workflow_order"
                action="edit"
                element={<AddTradeproOrderForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Order/add"
            element={
              <PrivateRoute
                module="workflow_order"
                action="add"
                element={<AddStreetfolioOrderForm />}
              />
            }
          />
          <Route
            path="WorkflowStreetfolio/Order/edit/:id"
            element={
              <PrivateRoute
                module="workflow_order"
                action="edit"
                element={<AddStreetfolioOrderForm />}
              />
            }
          />
          <Route
            path="Workflow/Order/view"
            element={
              <PrivateRoute
                module="workflow_order"
                action="view"
                element={<ViewWorkflowOrder />}
              />
            }
          />
          {/* WorkflowStreetfolio */}
          {/* <Route
            path="WorkflowStreetfolio/LeadCreation"
            element={<PrivateRoute element={<WorkflowStreetFolioPage />} />}
          />
          <Route
            path="WorkflowStreetfolio/LeadCreation/add"
            element={<PrivateRoute element={<LeadCreationStreetFolioForm />} />}
          />
          <Route
            path="WorkflowStreetfolio/LeadCreation/edit/:id"
            element={<PrivateRoute element={<LeadCreationStreetFolioForm />} />}
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Subscriber"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscriber />} />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscriber/add"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscriberForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Subscriber/edit/:id"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscriberForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Subscriber/view"
            element={
              <PrivateRoute element={<ViewStreetFolioSubscriberOrder />} />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Subscription"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscription />} />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscription/add"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscriptionForm />} />
            }
          />
          <Route
            path="WorkflowStreetfolio/Subscription/edit/:id"
            element={
              <PrivateRoute element={<WorkflowStreetFolioSubscriptionForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Subscription/view"
            element={
              <PrivateRoute
                element={<WorkflowStreetFolioViewSubscriptionOrder />}
              />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Order"
            element={<PrivateRoute element={<WorkflowStreetFolioOrder />} />}
          />
          <Route
            path="WorkflowStreetfolio/Order/add"
            element={
              <PrivateRoute element={<WorkflowStreetFolioOrderForm />} />
            }
          />
          <Route
            path="WorkflowStreetfolio/Order/edit/:id"
            element={
              <PrivateRoute element={<WorkflowStreetFolioOrderForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowStreetfolio/Order/view"
            element={
              <PrivateRoute
                element={<WorkflowStreetFolioViewWorkflowOrder />}
              />
            }
          /> */}
          {/* WorkflowTradepro */}
          {/* <Route
            path="WorkflowTradepro/LeadCreation"
            element={<PrivateRoute element={<WorkflowTradeproPage />} />}
          />
          <Route
            path="WorkflowTradepro/LeadCreation/add"
            element={<PrivateRoute element={<LeadCreationTradeproForm />} />}
          />
          <Route
            path="WorkflowTradepro/LeadCreation/edit/:id"
            element={<PrivateRoute element={<LeadCreationTradeproForm />} />}
          /> */}
          {/* <Route
            path="WorkflowTradepro/Subscriber"
            element={<PrivateRoute element={<WorkflowTradeproSubscriber />} />}
          />
          <Route
            path="WorkflowTradepro/Subscriber/add"
            element={
              <PrivateRoute element={<WorkflowTradeproSubscriberForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowTradepro/Subscriber/edit/:id"
            element={
              <PrivateRoute element={<WorkflowTradeproSubscriberForm />} />
            }
          />
          <Route
            path="WorkflowTradepro/Subscriber/view"
            element={<PrivateRoute element={<ViewTradeproSubscriberOrder />} />}
          /> */}
          {/* <Route
            path="WorkflowTradepro/Subscription"
            element={
              <PrivateRoute element={<WorkflowTradeproSubscription />} />
            }
          />
          <Route
            path="WorkflowTradepro/Subscription/add"
            element={
              <PrivateRoute element={<WorkflowTradeproSubscriptionForm />} />
            }
          />
          <Route
            path="WorkflowTradepro/Subscription/edit/:id"
            element={
              <PrivateRoute element={<WorkflowTradeproSubscriptionForm />} />
            }
          /> */}
          {/* <Route
            path="WorkflowTradepro/Subscription/view"
            element={
              <PrivateRoute
                element={<WorkflowTradeproViewSubscriptionOrder />}
              />
            }
          /> */}
          {/* <Route
            path="WorkflowTradepro/Order"
            element={<PrivateRoute element={<WorkflowTradeproOrder />} />}
          />
          <Route
            path="WorkflowTradepro/Order/add"
            element={<PrivateRoute element={<WorkflowTradeproOrderForm />} />}
          />
          <Route
            path="WorkflowTradepro/Order/edit/:id"
            element={<PrivateRoute element={<WorkflowTradeproOrderForm />} />}
          /> */}
          {/* <Route
            path="WorkflowTradepro/Order/view"
            element={
              <PrivateRoute element={<WorkflowTradeproViewWorkflowOrder />} />
            }
          /> */}
          {/* General */}
          <Route
            path="Website/StreetViewCategory"
            element={<PrivateRoute element={<StreetViewCategory />} />}
          />
          <Route
            path="Website/StreetViewCategory/add/"
            element={<PrivateRoute element={<GeneralCategoryForm />} />}
          />
          <Route
            path="Website/Offers"
            element={<PrivateRoute element={<OffersPage />} />}
          />
          <Route
            path="Website/Offers/add/"
            element={<PrivateRoute element={<OfferForm />} />}
          />
          <Route
            path="Website/Testimonial"
            element={<PrivateRoute element={<ManageTestimonial />} />}
          />
          <Route path="/downloadPayslip/:id" element={<Payslip />} />
          <Route
            path="Website/Testimonial/add/"
            element={<PrivateRoute element={<TestimonialForm />} />}
          />
          <Route
            path="Website/AskExpert"
            element={<PrivateRoute element={<AskExpertList />} />}
          />
          <Route
            path="Website/AskExpert/add/"
            element={<PrivateRoute element={<AskExpertForm />} />}
          />
          <Route
            path="Website/AskExpert/edit/:id"
            element={<PrivateRoute element={<AskExpertForm />} />}
          />
          <Route
            path="CustomPages"
            element={
              <PrivateRoute
                module="policy_pages"
                action="view"
                element={<CustomPagesList />}
              />
            }
          />
          <Route
            path="CustomPages/add/"
            element={
              <PrivateRoute
                module="policy_pages"
                action="add"
                element={<CustomPageForm />}
              />
            }
          />
          <Route
            path="CustomPages/edit/:id"
            element={
              <PrivateRoute
                module="policy_pages"
                action="edit"
                element={<EditCustomPage />}
              />
            }
          />
          <Route
            path="DynamicBlogs"
            element={
              <PrivateRoute
                module="dynamic_blogs"
                action="view"
                element={<DynamicBlogsList />}
              />
            }
          />
          <Route
            path="DynamicBlogs/edit/:id"
            element={
              <PrivateRoute
                module="dynamic_blogs"
                action="edit"
                element={<EditDynemicBlogPage />}
              />
            }
          />
          <Route
            path="/Website/Sitemap"
            element={
              <PrivateRoute
                module="streetgains_sitemap"
                action="view"
                element={<WebsiteSitemapList />}
              />
            }
          />
          <Route
            path="/Website/Sitemap/edit/:id"
            element={
              <PrivateRoute
                module="streetgains_sitemap"
                action="edit"
                element={<EditSitemap />}
              />
            }
          />
          <Route
            path="/Website/Sitemap/add"
            element={
              <PrivateRoute
                module="streetgains_sitemap"
                action="add"
                element={<AddSitemap />}
              />
            }
          />
          <Route
            path="/WebsiteReviews"
            element={
              <PrivateRoute
                module="streetgains_reviews"
                action="view"
                element={<WebsiteReviews />}
              />
            }
          />
          <Route
            path="/WebsiteReviews/add"
            element={
              <PrivateRoute
                module="streetgains_reviews"
                action="add"
                element={<WebsiteReviewsForm />}
              />
            }
          />
          <Route
            path="/WebsiteReviews/edit/:id"
            element={
              <PrivateRoute
                module="streetgains_reviews"
                action="edit"
                element={<WebsiteReviewsForm />}
              />
            }
          />
          {/* Payroll */}
          <Route
            path="Payroll/SetSalary/list"
            element={
              <PrivateRoute
                module="payroll_set_salary"
                action="view"
                element={<SetSalary />}
              />
            }
          />
          <Route
            path="Payroll/SetSalary/demo"
            element={
              <PrivateRoute
                module="payroll_set_salary"
                action="view"
                element={<DemoSalary />}
              />
            }
          />
          <Route
            path="Payroll/SetSalary/viewSalaryOrder"
            element={
              <PrivateRoute
                module="payroll_set_salary"
                action="view"
                element={<ViewSalaryOrder />}
              />
            }
          />
          <Route
            path="Payroll/SetSalary/viewReportOrder"
            element={
              <PrivateRoute
                module="payroll_set_salary"
                action="view"
                element={<ViewReportOrder />}
              />
            }
          />
          <Route
            path="Payroll/Employee/index"
            element={
              <PrivateRoute
                module="payroll_employee"
                action="view"
                element={<EmployeeSalary />}
              />
            }
          />
          <Route
            path="Payroll/Employee/viewSalary/:id"
            element={
              <PrivateRoute
                module="payroll_employee"
                action="edit"
                element={<EmployeeSalaryView />}
              />
            }
          />
          <Route
            path="Payroll/SalaryReport"
            element={
              <PrivateRoute
                module="payroll_salary_report"
                action="view"
                element={<SalaryReport />}
              />
            }
          />
          <Route
            path="Payroll/PayrollReport"
            element={
              <PrivateRoute
                module="payroll_salary_report"
                action="view"
                element={<PayrollReport />}
              />
            }
          />
          <Route
            path="Payroll/SalaryReport/editPayslip/:id"
            element={
              <PrivateRoute
                module="payroll_salary_report"
                action="edit"
                element={<EditSalaryReport />}
              />
            }
          />
          {/* LeaveManagment */}
          <Route
            path="LeaveManagement/LeaveType/index"
            element={<PrivateRoute element={<ManageLeaveTypes />} />}
          />
          <Route
            path="LeaveManagement/LeaveType/add"
            element={<PrivateRoute element={<LeaveTypeForm />} />}
          />
          <Route
            path="LeaveManagement/ApplyLeave/index"
            element={<PrivateRoute element={<LeaveManagementApplyList />} />}
          />
          <Route
            path="LeaveManagement/ApplyLeave/add"
            element={<PrivateRoute element={<ApplyLeaveForm />} />}
          />
          <Route
            path="payroll/employee/viewSalary:employeeId"
            element={<EmployeeSalaryView />}
          />
          <Route
            path="LeaveManagement/ManageLeaves/index"
            element={<PrivateRoute element={<ManageLeaves />} />}
          />
          <Route path="/" element={<PrivateRoute element={<Dashboard />} />} />{" "}
          <Route
            path="/research/whatsapp"
            element={
              <PrivateRoute
                module="campaign_whatsapp"
                action="view"
                element={<SendWhatsappBulk />}
              />
            }
          />
          <Route
            path="/research/SendMail"
            element={
              <PrivateRoute
                module="campaign_email"
                action="view"
                element={<SendEmail />}
              />
            }
          />
          <Route
            path="/research/SocialSharing"
            element={
              <PrivateRoute
                module="socialsharing"
                action="view"
                element={<SocialSharing />}
              />
            }
          />
          <Route
            path="/research/sg-messages"
            element={
              <PrivateRoute
                module="chat_sg"
                action="view"
                element={<ChatSg />}
              />
            }
          />
          <Route
            path="/sg-messages"
            element={
              <PrivateRoute
                module="chat_sg"
                action="view"
                element={<ChatSg />}
              />
            }
          />
          <Route
            path="/research/chat-sg"
            element={
              <PrivateRoute
                module="chat_sg"
                action="view"
                element={<ChatSg />}
              />
            }
          />
          <Route
            path="/research/sf-messages"
            element={
              <PrivateRoute
                module="chat_sf"
                action="view"
                element={<ChatSf />}
              />
            }
          />
          <Route
            path="/sf-messages"
            element={
              <PrivateRoute
                module="chat_sf"
                action="view"
                element={<ChatSf />}
              />
            }
          />
          <Route
            path="/research/chat-sf"
            element={
              <PrivateRoute
                module="chat_sf"
                action="view"
                element={<ChatSf />}
              />
            }
          />
          <Route
            path="/Orders/settlements"
            element={
              <PrivateRoute
                module="orders_settlements"
                action="view"
                element={<OrderSettlement />}
              />
            }
          />
          <Route
            path="/orders/infoSettlements/:id"
            element={
              <PrivateRoute
                module="orders_settlements"
                action="view"
                element={<OrderSettlementInfo />}
              />
            }
          />
          {/* Report Module */}
          <Route
            path="/Report/BulkCampaign"
            element={
              <PrivateRoute
                module="report_bulkcampaign"
                action="view"
                element={<BulkCampingReport />}
              />
            }
          />
          <Route
            path="/Report/BulkCampaign/details/:cid"
            element={
              <PrivateRoute
                module="report_bulkcampaign"
                action="view"
                element={<CampingDetails />}
              />
            }
          />
          <Route
            path="/Report/SingleCampaign"
            element={
              <PrivateRoute
                module="single_bulkcampaign"
                action="view"
                element={<SingleCampaignReport />}
              />
            }
          />
          <Route
            path="Report/SingleCampaign/details/:cid"
            element={
              <PrivateRoute
                module="single_bulkcampaign"
                action="view"
                element={<SingleCampingDetails />}
              />
            }
          />
          <Route
            path="Report/Salary"
            element={<PrivateRoute element={<Salary />} />}
          />
          <Route
            path="Report/Installation"
            element={<PrivateRoute element={<InstallationReport />} />}
          />
          <Route
            path="Report/revenueReport"
            element={<PrivateRoute module="report_revenue" action="view" element={<RevenueReport />} />}
          />
          <Route
            path="Report/revenueChart"
            element={<PrivateRoute module="revenue_chart" action="view" element={<RevenueChart />} />}
          />
          <Route
            path="Report/Subscription"
            element={<PrivateRoute module="report_subscription" action="view" element={<SubscriptionReport />} />}
          />
          <Route
            path="Report/Distributor"
            element={<PrivateRoute module="report_distributor" action="view" element={<DistributorReport />} />}
          />
          <Route
            path="Report/Distributor/:id"
            element={<PrivateRoute module="report_distributor" action="view" element={<DistributorReportDetail />} />}
          />
          <Route
            path="Report/adsReport"
            element={<PrivateRoute module="report_ads" action="view" element={<AdsReport />} />}
          />
          <Route
            path="Report/adsReport/campaign-update"
            element={<PrivateRoute module="report_ads" action="view" element={<AdsCampaignUpdate />} />}
          />
          <Route
            path="Report/adsReport/:platform"
            element={<PrivateRoute module="report_ads" action="view" element={<AdsReportDetail />} />}
          />
          <Route
            path="Report/adsReport/campaign/:campaignName"
            element={<PrivateRoute module="report_ads" action="view" element={<AdsReportDetail />} />}
          />
          <Route
            path="Report/SubscriberStatus"
            element={<PrivateRoute module="report_subscriberstatus" action="view" element={<SubscriberStatusReport />} />}
          />
          <Route
            path="Report/callSummary/report"
            element={<PrivateRoute module="report_callsummary" action="view" element={<CallSummaryReport />} />}
          />
          <Route
            path="/Report/emailStatistics"
            element={<PrivateRoute module="report_emailstatistics" action="view" element={<EmailStatisticsReport />} />}
          />
          <Route
            path="/Report/emailStatistics/:messageId"
            element={<PrivateRoute module="report_emailstatistics" action="view" element={<EmailEventLogsReport />} />}
          />
          <Route
            path="/Report/whatsappReport"
            element={<PrivateRoute module="whatsapp_chat_report" action="view" element={<WhatsappReport />} />}
          />
          <Route
            path="/Report/whatsappOptin"
            element={<PrivateRoute module="whatsapp_optin" action="view" element={<WhatsappOptinReport />} />}
          />
          <Route
            path="/Report/subscriberData"
            element={<PrivateRoute module="report_subscriber_data" action="view" element={<SubscriberDataReport />} />}
          />
          <Route
            path="/Report/linkTracking"
            element={<PrivateRoute module="report_linktracking" action="view" element={<LinkTrackingReport />} />}
          />
          <Route
            path="/utm-links"
            element={<PrivateRoute module="utm_links" action="view" element={<UtmLinks />} />}
          />
          <Route
            path="/utm-links/add"
            element={<PrivateRoute module="utm_links" action="add" element={<AddUtmLink />} />}
          />
          <Route
            path="/Settings/utm-links"
            element={<PrivateRoute module="utm_links" action="view" element={<UtmLinks />} />}
          />
          <Route
            path="/Settings/utm-links/add"
            element={<PrivateRoute module="utm_links" action="add" element={<AddUtmLink />} />}
          />
          <Route
            path="/Settings/UtmLinks"
            element={<PrivateRoute module="utm_links" action="view" element={<UtmLinks />} />}
          />
          <Route
            path="/Settings/UtmLinks/add"
            element={<PrivateRoute module="utm_links" action="add" element={<AddUtmLink />} />}
          />
          <Route
            path="Report/leadSourceReport"
            element={<PrivateRoute module="lead_source_report" action="view" element={<LeadSourceReport />} />}
          />
          <Route
            path="Report/subscriberAnalysisChart"
            element={<PrivateRoute module="subscriber_analysis_chart" action="view" element={<SubscriberAnalysisChart />} />}
          />
          <Route
            path="Website/LeadSourceCost"
            element={<PrivateRoute module="website_leadsourcecost" action="view" element={<ManageLeadSourceCost />} />}
          />
          <Route
            path="Website/LeadSourceCost/add"
            element={<PrivateRoute module="website_leadsourcecost" action="add" element={<LeadSourceCostForm />} />}
          />
          <Route
            path="Website/LeadSourceCost/edit/:id"
            element={<PrivateRoute module="website_leadsourcecost" action="edit" element={<LeadSourceCostForm />} />}
          />
          <Route
            path="Report/subscriptionAnalysisReport"
            element={<PrivateRoute module="report_subscription_analysis" action="view" element={<SubscriptionAnalysisReport />} />}
          />
          <Route
            path="Report/subscriberAnalysisReport"
            element={<PrivateRoute module="report_subscriber_analysis" action="view" element={<SubscriberAnalysisReport />} />}
          />
          <Route
            path="Report/subscriptionAnalysisChart"
            element={<PrivateRoute module="subscription_analysis_chart" element={<SubscriptionAnalysisChart />} />}
          />
          <Route
            path="Twitter/getTwitterPost"
            element={<PrivateRoute element={<TwitterDailyPost />} />}
          />
          <Route
            path="Report/Broadcast"
            element={<PrivateRoute element={<BroadcastReport />} />}
          />
          <Route
            path="Report/Broadcast/details/:cid"
            element={<PrivateRoute element={<BroadcastDetails />} />}
          />
          <Route
            path="Report/ExecutivePerformance"
            element={<PrivateRoute element={<ExecutivePerformanceReport />} />}
          />
          <Route
            path="AnalysisDashboard"
            element={<PrivateRoute element={<AnalysisDashboard />} />}
          />
          <Route
            path="SalesAnalysisDashboard"
            element={<PrivateRoute element={<SalesAnalysisDashboard />} />}
          />
          <Route
            path="sales-analysis"
            element={<PrivateRoute element={<SalesAnalysisDashboard />} />}
          />

          {/* Streetlearn Module Routes */}
          <Route
            path="streetlearn/analytics"
            element={<PrivateRoute module="streetlearn" action="view" element={<StreetlearnAnalytics />} />}
          />
          <Route
            path="streetlearn/learners"
            element={<PrivateRoute module="streetlearn_learners" action="view" element={<StreetlearnLearners />} />}
          />
          <Route
            path="streetlearn/learners/:id"
            element={<PrivateRoute module="streetlearn_learners" action="view" element={<StreetlearnLearnerDetail />} />}
          />
          <Route
            path="streetlearn/curriculum"
            element={<PrivateRoute module="streetlearn" action="view" element={<StreetlearnCurriculum />} />}
          />
          <Route
            path="streetlearn/curriculum/lessons/:id/studio"
            element={<PrivateRoute module="streetlearn" action="view" element={<LessonStudio />} />}
          />
          <Route
            path="streetlearn/questions"
            element={<PrivateRoute module="streetlearn" action="view" element={<StreetlearnQuestions />} />}
          />
          <Route
            path="streetlearn/exam-settings"
            element={<PrivateRoute module="streetlearn" action="view" element={<StreetlearnExamSettings />} />}
          />
          <Route
            path="streetlearn/orders"
            element={<PrivateRoute module="streetlearn_orders" action="view" element={<StreetlearnOrders />} />}
          />
          <Route
            path="streetlearn/certificates"
            element={<PrivateRoute module="streetlearn_learners" action="view" element={<StreetlearnCertificates />} />}
          />

        </Route>
      </Routes>
    </Router>
  );
};

export default App;
